export const blockIconsFileCloud = (
	<span className='material-symbols-outlined'>cloud</span>
);
